<template>
  <section>
    <Tabs :value="tab" @on-click="tabClick">
        <TabPane label="未办结" name="未办结"></TabPane>
        <TabPane label="已办结" name="已办结"></TabPane>
    </Tabs>
    <!--顶部查询条件-->
    <Form ref="tqtYqlSearchForm" :model="tqtYql" inline>
      <FormItem prop="busiNumber">
        <Input v-model="tqtYql.busiNumber" maxlength="20" placeholder="请输入工单编号" clearable></Input>
      </FormItem>
      <FormItem prop="name">
        <Input v-model="tqtYql.name" maxlength="30" placeholder="请输入姓名" clearable></Input>
      </FormItem>
      <FormItem prop="phone">
        <Input v-model="tqtYql.phone" maxlength="20" placeholder="请输入联系方式" clearable></Input>
      </FormItem>
      <FormItem prop="identity">
        <Input v-model="tqtYql.identity" maxlength="18" placeholder="请输入身份证号码" clearable></Input>
      </FormItem>
      <FormItem prop="type">
        <Select v-model="tqtYql.type" placeholder="请选择诉求类型" clearable style="width:170px">
          <Option v-for="item in typeoptions" :value="item.value" :key="item.value">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="emotion">
        <Select v-model="tqtYql.emotion" placeholder="请选择诉求情绪" clearable style="width:170px">
          <Option v-for="item in emotionoptions" :value="item.value" :key="item.value">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <!--查询按钮-->
      <FormItem>
        <Button shape="circle" @click="chongzhi">重置</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" shape="circle" @click="listTable(1)">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" shape="circle" @click="exportExcel">导出</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" :data="tableData"></Table>
    <div class="page-area">
      <Page :total="pageTotal" :page-size="pageLength" :current="pageOffset" @on-change="handlePageChange" show-total
            show-elevator/>
    </div>
  </section>
</template>
<script>
import util from '@/libs/util.js';
export default {
  name: "tqt_yql",
  data() {
    return {
      tab: '未办结',
      typeoptions: [
        {value: '12350工单'},
        {value: '举报'},
        {value: '表扬'},
        {value: '建议'},
        {value: '求助'},
        {value: '咨询'},
        {value: '投诉'},
        {value: '好差评'}
      ],
      emotionoptions: [
        {value: '开心'},
        {value: '激动'},
        {value: '生气'},
        {value: '难过'},
        {value: '疑惑'},
        {value: '平淡'},
        {value: '其他'}
      ],
      //分页参数
      pageLength: 10, // 每页条数
      pageTotal: 0,//总数
      pageOffset: 1, //页码
      showModel: false,
      //查询参数
      tqtYql: {
        busiNumber: '',
        name: '',
        phone: '',
        identity: '',
        type: '',
        emotion: ''
      },
      columns: [
        {
          key: 'order',
          title: '序号',
          align: 'center',
          width: 70
        },
        {
          key: "busiNumber",
          title: "工单编号",
          align: 'center',
          tooltip: true,
        },
        {
          key: "name",
          title: "姓名",
          align: 'center',
          tooltip: true,
        },
        {
          key: "phone",
          title: "联系方式",
          align: 'center',
          tooltip: true,
        },
        {
          key: "identity",
          title: "身份证号码",
          align: 'center',
          tooltip: true,
        },
        {
          key: "type",
          title: "诉求类型",
          align: 'center',
          tooltip: true,
        },
        {
          key: "emotion",
          title: "诉求情绪",
          align: 'center',
          tooltip: true,
        },
        {
          title: '操作',
          align: "center",
          width: 100,
          key: "id",
          render: (h, params) => {
            return h("div", [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  textDecoration:'underline'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'tqt_yql_item',
                      query: {
                        id: params.row.id
                      }
                    })
                  }
                }
              }, '详情')
            ])
          }
        }

      ],
      tableData: []
    };
  },
  mounted() {
    this.listTable(1)
  },
  methods: {
    // tab切换
    tabClick (value) {
      this.tab = value
      this.listTable(1)
    },
    // 导出
    exportExcel() {
      let params = {
        exportType: this.tab == '未办结' ? 1 : 2,
        busiNumber: this.tqtYql.busiNumber,
        name: this.tqtYql.name,
        phone: this.tqtYql.phone,
        identity: this.tqtYql.identity,
        type: this.tqtYql.type,
        emotion: this.tqtYql.emotion,
      }
      util.http.post(`/api/tqt/petition/exportList`, { params }, { responseType: 'blob' }).then(res => {
        if (res.headers['content-disposition']) {
          let name = res.headers['content-disposition'].split('=')[1]
          name = decodeURI(name)
          let fileName = {
            name: name,
            type: res.headers['content-type']
          }
          this.funDown(res.data, fileName)
        }
      })
    },
    funDown (data, fileName) {
      let blob = new Blob([data], {type: fileName.type})
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName.name)
      } else {
        let link = document.createElement('a')
        link.target = '_blank'
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName.name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }
    },
    // 重置
    chongzhi () {
      this.$set(this, 'tqtYql', this.$options.data.call(this).tqtYql)
      this.$refs.tqtYqlSearchForm.resetFields()
      this.listTable(1)
    },
    //渲染表格数据
    listTable(page) {
      if (page) {
        this.pageOffset = 1
      }
      let _this = this;
      util.http
        .post(this.tab == '未办结' ? '/api/tqt/petition/listCompleting' : '/api/tqt/petition/listCompleted',
          {
            pageNum: _this.pageOffset,
            pageSize: _this.pageLength,
            ...this.tqtYql
          }
        )
        .then(function (response) {
          console.log('🤡 ❗ response:', response)
          let list = response.data.result.list
          for (let i = 0; i < list.length; i++) {
            list[i].order = i + 1 + (_this.pageOffset - 1) * _this.pageLength
          }
          _this.pageTotal = response.data.result.total
          _this.tableData = list
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 分页
    handlePageChange(current) {
      this.pageOffset = current;
      this.listTable();
    }
  }
};
</script>
<style scoped>
.query-model {
  width: 170px;
}

.page-area {
  display: flex;
  justify-content: flex-end;
  padding-top: 35px;
  padding-right: 50px;
}
</style>
